import { IN_QUEUE_PATH } from "infrastructure/RouterApp";
import { useCluster } from "in_queue/contexts/ClusterContext";
import { ScenarioStage } from "in_queue/types/scenarioType";
import { useParams } from "react-router-dom";
import {
    BULK_SCENARIO_UPLOAD_PATH,
    DUPLICATE_FROM_PARAM,
    SCENARIO_STAGE_PARAM
} from "./scenarioBuilderParams";

interface ScenarioBuilderRoutes {
    readonly createHref: (stage: ScenarioStage) => string;
    readonly bulkUploadHref: (stage: ScenarioStage) => string;
    readonly editHref: (scenarioId: string) => string;
    readonly duplicateHref: (scenarioId: string) => string;
}

export const useScenarioBuilderRoutes = (): ScenarioBuilderRoutes => {
    const cluster = useCluster();
    const { projectId } = useParams();

    const base = `/${IN_QUEUE_PATH}/${cluster.slug}/${projectId}/scenario`;

    return {
        createHref: (stage: ScenarioStage) =>
            `${base}/new?${SCENARIO_STAGE_PARAM}=${stage}`,
        bulkUploadHref: (stage: ScenarioStage) =>
            `${base}/${BULK_SCENARIO_UPLOAD_PATH}?${SCENARIO_STAGE_PARAM}=${stage}`,
        editHref: (scenarioId: string) => `${base}/${scenarioId}/edit`,
        duplicateHref: (scenarioId: string) =>
            `${base}/new?${DUPLICATE_FROM_PARAM}=${scenarioId}`
    };
};
